export default Object.freeze({
  Actualizacion: 1,
  Creacion: 2,
});
